module.exports = __webpack_public_path__ + "static/pinkbeartowel-6edf5526fc6338d51666af22367126b0.png";